import {
  getBoardingPassengers,
  getPassengerCount,
} from '@backoffice-frontend/ad-passenger-list'
import { useTranslation } from 'react-i18next'
import { ActionCard } from '../ActionCards/ActionCard'
import type { AdVehicleStreamBoardingPassengersWaypointFragment } from './BoardingPassengers.hook'
import { BoardingPassengerCardWithAuthentication } from './BoardingPassengerWithAuthentication'

export const BoardingPassengers = ({
  waypoint,
  vehicleId,
}: {
  waypoint: AdVehicleStreamBoardingPassengersWaypointFragment
  vehicleId: string
}) => {
  const { t } = useTranslation()

  const boardingPassengers = getBoardingPassengers(waypoint)
  const boardingPassengerCount = getPassengerCount(boardingPassengers)

  if (boardingPassengerCount === 0) return null

  return (
    <ActionCard headline={t('adFleetMap_cscGuideBoardingPassengers_header')}>
      <div
        css={theme => ({
          display: 'flex',
          flexDirection: 'column',
          gap: theme.spacing(2),
          padding: theme.spacing(2),
        })}
      >
        {boardingPassengers.map(
          ({ customer, seats, eta, trip, notShownUpAt, pickedUpAt }) => (
            <BoardingPassengerCardWithAuthentication
              key={trip.id}
              vehicleId={vehicleId}
              tripId={trip.id}
              customer={customer}
              waypointStop={waypoint.stop}
              seats={seats}
              eta={eta}
              isNoShow={!!notShownUpAt}
              isBoarded={!!pickedUpAt}
            />
          ),
        )}
      </div>

      <div css={{ flexGrow: 1 }} />
    </ActionCard>
  )
}
